import { render, staticRenderFns } from "./InvoiceOrder.vue?vue&type=template&id=f2c73930&scoped=true"
import script from "./InvoiceOrder.vue?vue&type=script&lang=js"
export * from "./InvoiceOrder.vue?vue&type=script&lang=js"
import style0 from "./InvoiceOrder.vue?vue&type=style&index=0&id=f2c73930&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c73930",
  null
  
)

export default component.exports